var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 596,
    viewBox: "0 0 518 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M-236.912 545.414C-180.943 506.194 -159.781 454.481 -173.426 390.276C-193.894 293.969 -171.503 232.49 -109.813 227.486C-48.1221 222.481 10.0965 292.306 25.6811 375.885C41.2657 459.465 127.957 461.777 162.34 445.218C196.724 428.659 216.462 395.27 215.073 358.881C212.001 278.404 100.327 214.282 102.94 140.088C105.553 65.8942 197.376 38.6461 254.979 105.466C257.817 108.758 260.708 111.857 263.644 114.767C322.674 173.289 400.026 155.997 435.396 112.59C496.731 37.3199 468.761 -43.1234 370.35 -97.706C222.196 -183.73 143.342 -278.02 133.789 -380.579",
    stroke: "url(#paint0_linear_297_924)",
    strokeWidth: 100,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_924",
    x1: -247.313,
    y1: 578.724,
    x2: 832.035,
    y2: -48.2901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.5fa06d7b404921a3873eac8ebe344b4f.svg";
export { ForwardRef as ReactComponent };